export default {"src":"/_next/static/media/bath.7e3362fc.svg","height":2893,"width":4953,"blurWidth":0,"blurHeight":0};